import {IntlFormatters, MessageDescriptor, useIntl} from 'react-intl'
import {useSelector} from 'react-redux'
import {getShouldShowYourChoiceTag} from 'modules/search/selectors'

import {getCancellationDeadline} from '@vio/core/src/offer/business/cancellationPenalties'
import {
  getRoomLabels,
  roomLabels
} from '@vio/core/src/offer/business/getRoomLabels'
import {SearchOffer} from '@vio/core/src/offer/types/SearchOffer'

interface UseGetRoomLabelsProps {
  offer: SearchOffer
  shouldShowFreeCancellationDate?: boolean
  isSplitBooking?: boolean
  /** Added for 58b14194-ota-first-hotel-card-v1. */
  showYourSelection?: boolean
}

interface GetRoomLabelsTranslatedProps {
  labels: MessageDescriptor[]
  freeCancellationDeadlineFormatted?: string
  formatMessage: IntlFormatters['formatMessage']
}

export const getRoomLabelsTranslated = ({
  labels = [],
  freeCancellationDeadlineFormatted,
  formatMessage
}: GetRoomLabelsTranslatedProps): string[] => {
  const values = {
    [roomLabels.freeCancellationDeadline.id]: {
      date: freeCancellationDeadlineFormatted
    }
  }

  return labels.map(message => formatMessage(message, values[message.id] || {}))
}

export const useGetRoomLabels = ({
  offer,
  shouldShowFreeCancellationDate = false,
  isSplitBooking = false,
  showYourSelection = true
}: UseGetRoomLabelsProps): string[] => {
  const {formatMessage, formatDate} = useIntl()
  const shouldShowYourChoice = useSelector(
    getShouldShowYourChoiceTag(offer, isSplitBooking)
  )

  const labels = getRoomLabels({
    offer,
    shouldShowFreeCancellationDate,
    shouldShowYourChoice: showYourSelection && shouldShowYourChoice,
    isSplitBooking
  })

  const freeCancellationDeadline = getCancellationDeadline(
    offer?.cancellationPenalties
  )

  const freeCancellationDeadlineFormatted = formatDate(
    freeCancellationDeadline,
    {
      day: '2-digit',
      month: 'short',
      timeZone: 'UTC'
    }
  )

  return getRoomLabelsTranslated({
    labels,
    freeCancellationDeadlineFormatted,
    formatMessage
  })
}
